import React from 'react';
import {Button, Chip, Divider, Paper, Typography} from "@material-ui/core";
import {motion} from "framer-motion";
import FBPagination from "./FBPagination";
import clsx from "clsx";

const PatentSearchResults = ({patents, extra, handleFetchPage, openPatentDetails, openApplicationStatus}) => {
    if (extra.total_result === '0') {
        return <Typography className='text-center' color={"textSecondary"}>0 Results</Typography>
    }
    return (
        <Paper
            component={motion.div}
            initial={{y: -20}}
            animate={{y: 0}}
            className={clsx('flex flex-col shadow rounded-none', extra.total_result === '0' && 'hidden')}>
            <div className='p-2 px-4 flex flex-row justify-between items-center'>
                <Typography color={"textSecondary"}>{extra.total_result} Results</Typography>
                <FBPagination current_page={parseInt(extra.current_page)} total_pages={parseInt(extra.total_pages)} handleFetchPage={handleFetchPage}/>
            </div>
            <Divider/>

            {patents.map(patent => (
                <div className='p-4 border-b'>
                    <Typography style={{fontWeight: 500}}>{patent.title}</Typography>
                    <div className='flex flex-row justify-between items-end'>
                        <div>
                            <Typography>
                                <span style={{fontWeight: 500}}>Application Date : </span>{patent.application_date}
                            </Typography>
                            <Typography><span style={{fontWeight: 500}}>Application Number : </span>{patent.application_number}
                            </Typography>
                            <Chip label={patent.status}
                                  variant={"outlined"}
                                  size={"small"}
                                  color={patent.status === 'Published' ? "primary" : ""}
                                  className='rounded-none mt-1'/>
                        </div>
                        <div className='flex flex-row space-x-2'>
                            <Button color={"primary"} variant='outlined' size={"small"} onClick={()=>openPatentDetails(patent.application_number)}>Patent Details</Button>
                            <Button color={"primary"} variant='contained' size='small' onClick={()=>openApplicationStatus(patent.application_number)}>Application Status</Button>
                        </div>
                    </div>

                </div>
            ))}
            <div className='p-2 px-4 flex flex-row justify-between items-center'>
                <Typography color={"textSecondary"}></Typography>
                <FBPagination current_page={parseInt(extra.current_page)} total_pages={parseInt(extra.total_pages)} handleFetchPage={handleFetchPage}/>
            </div>

        </Paper>
    )
}

export default PatentSearchResults;